import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import CustomerBookings from "@/components/Bookings/customer/CustomerBookings.vue";
import { BookingService } from "@/services/BookingService";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerBookingsView',
  async setup(__props, { expose: __expose }) {
  __expose();

let __temp: any, __restore: any

const bookings = ref<any[]>([]);
let bookingsService = new BookingService();
bookings.value = (
  ([__temp,__restore] = _withAsyncContext(() => bookingsService.getAll())),
  __temp = await __temp,
  __restore(),
  __temp
);
console.log(bookings);

const __returned__ = { bookings, get bookingsService() { return bookingsService }, set bookingsService(v) { bookingsService = v }, CustomerBookings, get BookingService() { return BookingService }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})